import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Container, CircularProgress, Typography, Alert } from "@mui/material";
import { ssoLogin, fetchUserPermissions } from "../../services/auth";
import { useRBAC } from "../../context/RBACContext";

const SSOCallback = () => {
  const navigate = useNavigate();
  const { loadPermissions } = useRBAC();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleSSO = async () => {
      try {
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        console.log("SSO Callback - Code:", code);

        if (!code) {
          setError("No authorization code received from Keycloak");
          setLoading(false);
          return;
        }

        // Call SSO login
        const result = await ssoLogin(code);
        console.log("SSO Login Result:", result);

        // Fetch user permissions
        if (result.userId) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          await fetchUserPermissions(result.userId);
          await loadPermissions();
        }

        // Redirect to dashboard
        navigate("/dashboard", { replace: true, state: { refreshPermissions: true } });
      } catch (err) {
        console.error("SSO callback error:", err);
        setError(err.message || "SSO login failed. Please try again.");
        setLoading(false);
      }
    };

    handleSSO();
  }, [searchParams, navigate, loadPermissions]);

  // Redirect to login if error persists
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        navigate('/login', { replace: true });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [error, navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "var(--bg-main)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="sm">
        {loading && !error && (
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress size={48} sx={{ color: "var(--primary)", mb: 3 }} />
            <Typography variant="h6" sx={{ color: "var(--text-primary)" }}>
              Completing SSO Login...
            </Typography>
            <Typography variant="body2" sx={{ color: "var(--text-secondary)", mt: 1 }}>
              Please wait while we authenticate you.
            </Typography>
          </Box>
        )}

        {error && (
          <Box sx={{ textAlign: "center" }}>
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
            <Typography variant="body2" sx={{ color: "var(--text-secondary)" }}>
              Redirecting to login in a few seconds...
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default SSOCallback;
